import axios from "axios";
import { REACT_APP_API } from "../constants";
import { requestsFor } from "./headerService";
import { logoutHandler } from "../utils/navigateHandler";

// Database password management and the tenant's database settings
// (authnull-service internal/database: dbvault, rotation, nopolicy).
//
// Every call is POST with the console session in X-Authorization. The org
// always comes from the session: never send orgId. tenantId is optional and
// defaults to the session's tenant, so it isn't sent either.
//
// Each function resolves with the response body and rejects with the axios
// error, so callers can read error.response.status (403 admin only, 404 not
// found / not managed / not deployed, 400 bad input).
const instance = axios.create({ baseURL: `${REACT_APP_API}/api/v1/databaseService` });
const requests = requestsFor(instance);

const post = async (path, body = {}) => {
  try {
    const { data } = await requests.post(path, body);
    return data;
  } catch (error) {
    if (error?.response?.status === 401) logoutHandler();
    throw error;
  }
};

// { tenantId, accounts: [{ hostId, host, port, role, enabled, status, hasPassword, rotatedAt, nextDueAt, failures, detail }] }
export const listManagedPasswords = () => post("/users/password/list", {});

// { hostId, role, enabled }
export const setPasswordManaged = ({ hostId, role, enabled }) =>
  post("/users/password/manage", { hostId: Number(hostId), role, enabled: !!enabled });

// { hostId, role, queued: true }
export const rotatePasswordNow = ({ hostId, role }) =>
  post("/users/password/rotate", { hostId: Number(hostId), role });

// { revealId }: sends an approval push to the requesting admin's own phone.
export const requestPasswordReveal = ({ hostId, role }) =>
  post("/users/password/reveal", { hostId: Number(hostId), role });

// { status: pending | denied | expired | shown } or
// { status: "approved", password, showSeconds, rerotateAt }
export const getPasswordRevealResult = (revealId) => post("/users/password/reveal/result", { revealId });

// { tenantId, passwordRotationHours, updatedAt?, updatedBy? }
export const getPasswordRotationSetting = () => post("/settings/passwordRotation/get", {});

// hours must be a JSON number, a whole number 1–8760.
export const setPasswordRotationSetting = (hours) =>
  post("/settings/passwordRotation", { passwordRotationHours: Number(hours) });

// { tenantId, noPolicyAction: allow | mfa | deny, updatedAt?, updatedBy? }
export const getNoPolicySetting = () => post("/settings/noPolicy/get", {});

export const setNoPolicySetting = (noPolicyAction) => post("/settings/noPolicy", { noPolicyAction });
